var map = {
	"./ar/sound/index.vue": [
		7876,
		568,
		495
	],
	"./en/sound/index.vue": [
		9124,
		568,
		124
	],
	"./fa/sound/index.vue": [
		6625,
		568,
		625
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5820;
module.exports = webpackAsyncContext;